import * as types from "../types";
import advisorhq from "../../apis/advisorhq";

export const fetchCustomCurves = () => async (dispatch, getState) => {
  const response = await advisorhq.get("/api/custom_curve/");
  dispatch({ type: types.FETCH_CUSTOM_CURVES, payload: response.data });
};
